import React, { Component } from "react";

import VideoMain from "../Common/VideoMain/VideoMain";

class Workflow extends Component {
  render() {
    return <VideoMain {...this.props} isWorkflow={true} />;
  }
}

export default Workflow;



// WEBPACK FOOTER //
// ./src/containers/User/Workflow/Workflow.js